export default __webpack_public_path__ + "static/media/DNo.32-2.6465579f.jpg";